import { useLocalStorage } from '@mantine/hooks'
import type { FC } from 'react'
import FluentArrowAutofitHeight24Regular from '~icons/fluent/arrow-autofit-height-24-regular'
import FluentArrowAutofitHeightIn24Regular from '~icons/fluent/arrow-autofit-height-in-24-regular'
import { cx } from 'src/utils/cx'

interface FitToggleProps {
  localStorageKey: string
  className?: string
  iconClassName?: string
}

const FitToggle: FC<FitToggleProps> = ({
  localStorageKey,
  className,
  iconClassName,
}) => {
  const [fit, setFit] = useLocalStorage<'contain' | 'cover'>({
    key: localStorageKey,
    defaultValue: 'contain',
  })

  const toggleFit = () => {
    setFit(fit === 'contain' ? 'cover' : 'contain')
  }

  return (
    <button
      className={cx(
        'inline-grid place-content-center p-2 active:bg-black/10 dark:active:bg-white/10 rounded transition',
        className,
      )}
      onClick={toggleFit}
      title={
        fit === 'contain' ? 'Switch to cover (fill)' : 'Switch to contain (fit)'
      }
    >
      {fit === 'contain' ? (
        <FluentArrowAutofitHeightIn24Regular
          className={cx('size-5', iconClassName)}
        />
      ) : (
        <FluentArrowAutofitHeight24Regular
          className={cx('size-5', iconClassName)}
        />
      )}
    </button>
  )
}

export { FitToggle }
export const useFit = (localStorageKey: string) => {
  const [fit] = useLocalStorage<'contain' | 'cover'>({
    key: localStorageKey,
    defaultValue: 'contain',
  })
  return fit
}
